import { ScrollArea } from '../ScrollArea'
import { ScrollAreaRoot, ScrollAreaViewport, ScrollAreaScrollbar, ScrollAreaThumb } from './styles'

export function AlertScrollArea({ children, height, className, noScroll = false, noPadding = false }) {
  return (
    <ScrollArea.Root height={height} noScroll={noScroll} noPadding={noPadding} className={className} >
      {children}
    </ScrollArea.Root>
  )
}
